import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";

const tabs = [
    { label: "Overview", path: "/reports-analytics/summary" },
    { label: "Financial", path: "/reports-analytics/financial" },
    { label: "Revenue", path: "/reports-analytics/revenue" },
    { label: "Trips", path: "/reports-analytics/trips" },
    { label: "Users", path: "/reports-analytics/users" },
    { label: "Geographic", path: "/reports-analytics/geographic" },
    { label: "Operations", path: "/reports-analytics/operational" },
    { label: "Quality", path: "/reports-analytics/quality" },
];

export const ReportsAnalyticsLayout = () => {
    const { pathname } = useLocation();

    // Redirect index to summary
    if (pathname === "/reports-analytics" || pathname === "/reports-analytics/") {
        return <Navigate to="/reports-analytics/summary" replace />;
    }

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-bold text-slate-900 dark:text-white">
                    Reports & Analytics
                </h1>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                    Revenue, trips, users, and geographic insights
                </p>
            </div>

            {/* Tabs */}
            <div className="border-b border-slate-200 dark:border-slate-700">
                <nav className="-mb-px flex gap-6 overflow-x-auto">
                    {tabs.map((tab) => (
                        <NavLink
                            key={tab.path}
                            to={tab.path}
                            className={({ isActive }) =>
                                `whitespace-nowrap border-b-2 px-1 pb-3 text-sm font-medium transition-colors ${isActive
                                    ? "border-primary-600 text-primary-600 dark:border-primary-400 dark:text-primary-400"
                                    : "border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
                                }`
                            }
                        >
                            {tab.label}
                        </NavLink>
                    ))}
                </nav>
            </div>

            <Outlet />
        </div>
    );
};
